import CounselorList from './CounselorList';

export default CounselorList;